import classNames from "classnames";
import {Link} from "react-router";

import {Card} from "@/components/card/Card";
import {CDNImage} from "@/components/cdnImage/CDNImage.tsx";
import {PublicProfile} from "@/lib/types/isitdown";

import styles from "./SimilarServiceCard.module.scss";

interface SimilarServiceCardProps {
  service: PublicProfile;
}

export const SimilarServiceCard = ({service}: SimilarServiceCardProps) => {
  return (
    <Link to={`/${service.slug}`} className={styles.cardLink}>
      <Card variant="marketingWhite" className={styles.serviceCard}>
        <div className={styles.cardContent}>
          <div className={styles.serviceInfo}>
            <div className={styles.serviceIcon}>
              <CDNImage
                src={service.image}
                domain={service.slug}
                alt={service.slug}
                title={service.slug}
                className={styles.serviceImage}
              />
            </div>
            <div className={classNames("marketingTextBodyBold", styles.serviceDetails)}>
              {service.name || service.slug}
            </div>
          </div>
        </div>
      </Card>
    </Link>
  );
};
